import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { Experiences } from '@local/client-contracts';
import { UntilDestroy } from '@ngneat/until-destroy';
import { isEqual } from 'lodash';
import { OverlayPanel } from 'primeng/overlaypanel';
import { AvatarItemModel } from 'src/app/bar/models/avatar-item.model';
import { AvatarListService } from 'src/app/bar/services/avatar-list.service';
import { ExperiencesService } from 'src/app/bar/services/experiences.service';
import { ShareOptionsService } from 'src/app/bar/services/share-options.service';

@UntilDestroy()
@Component({
  selector: 'assistant-header-line',
  templateUrl: './assistant-header-line.component.html',
  styleUrls: ['./assistant-header-line.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssistantHeaderLineComponent {
  private _assistant: Experiences.ExperienceItem;
  experiencesWithEditMode = Experiences.ExperiencesWithEditMode;

  //created by
  displayModifiedTime: string;
  preDisplayModifiedTime: string;
  fullDetails: string;
  startModifiedPhrase: string;

  avatarsList: AvatarItemModel[] = [];

  @Input() set assistant(value: Experiences.ExperienceItem) {
    if (!value) {
      return;
    }

    const prevAssistant = this.assistant;
    this._assistant = value;

    if (this.assistant?.modifiedAt && !isEqual(prevAssistant?.modifiedAt, this.assistant?.modifiedAt)) {
      this.getAssistantTimePhrases();
    }

    if (
      (!prevAssistant && this.assistant) ||
      !this.shareOptionsService.compareShareOptions(prevAssistant?.shareOptions, this.assistant?.shareOptions)
    ) {
      this.createAvatarList();
    }
  }

  get assistant(): Experiences.ExperienceItem {
    return this._assistant;
  }

  constructor(
    private assistantService: ExperiencesService,
    private cdr: ChangeDetectorRef,
    private avatarListService: AvatarListService,
    private shareOptionsService: ShareOptionsService
  ) {}

  private async getAssistantTimePhrases() {
    const phrase = await this.assistantService.getAssistantTimePhrases(this.assistant);
    this.displayModifiedTime = phrase.displayModifiedTime;
    this.preDisplayModifiedTime = phrase.preDisplayModifiedTime.toLowerCase();
    this.fullDetails = phrase.fullDetails;
    this.startModifiedPhrase = phrase.startModifiedPhrase;
    this.cdr.markForCheck();
  }

  async createAvatarList() {
    this.avatarsList = await this.avatarListService.createAvatarList(
      this.assistant.createdBy,
      this.assistant.shareOptions,
      true,
      this.assistantService.SHARE_OPTIONS_ASSISTANTS
    );
    this.cdr.markForCheck();
  }

  onDeleteClick() {
    this.assistantService.deleteAssistant(this.assistant, true);
  }

  onShareClick() {
    this.assistantService.shareAssistant(this.assistant);
  }

  onHidePanel(op: OverlayPanel) {
    op.overlayVisible = false;
    op.cd.markForCheck();
  }
}
